const getWheelStatusColor = (status) => {
  switch (status) {
    case 'active':
      return {
        color: '#fff',
        background: '#3498db',
      }
    case 'inactive':
      return {
        color: '#fff',
        background: '#95a5a6',
      }
    default:
      return {
        color: '#999',
        background: '#fff',
      }
  }
}

export { getWheelStatusColor }
